<template>
  <div class="evaluate-wrap">
    <div class="container">
      <div class="col-left">
        <product-info class="product-info" :pic="params.pic" :product-name="params.productName"  @back="reselect"></product-info>
      </div>
      <hr class="hr visible-xs-block">
      <div class="col-right">
        <Evaluate v-model="selects" />
        <h-button class="btn-lg hidden-xs" type="primary" :disabled="!isCompleted" :loading="loading" size="large" @click="submit">{{ $t('evaluate.submit') }}</h-button>
      </div>
    </div>
    <div class="bg-white visible-xs-block sticky footer-fiexed">
      <h-button class="btn-lg" type="primary" :disabled="!isCompleted" :loading="loading" size="large" @click="submit">{{ $t('evaluate.submit') }}</h-button>
    </div>
  </div>
</template>

<script type="text/javascript">
import EvaluateCore from '@/core/evaluate/index';
import productParam from '@/core/evaluate/store.js';

export default {
  asyncData ({ store, route }) {
    return store.dispatch('productParam/get', route.params.productId);
  },
  registerModule (store, preserveState) {
    store.registerModule('productParam', productParam, { preserveState });
  },
  destroyed () {
    this.$store.unregisterModule('productParam');
  },
  methods: {
		reselect () {
			this.$router.push({
				name: 'Products'
			})
		},
  },
  extends: EvaluateCore
};
</script>

<style src="./inquery.css" scoped></style>
